<template>
    <cadastro-simples-list
        endpoint="situacao-familiar"
        rota-base="/admin/situacao-familiar"
        titulo="SITUAÇÕES FAMILIARES"
        titulo-singular="Situação Familiar"
        :colunas-extras='[]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
